const subModuleItem = {
  bindings: {
    module: '<',
    active: '<',
    onSelect: '&'
  },
  templateUrl:
    '/modules/configurationManagement/train-management/module-list/sub-module-item/sub-module-item.html',
  controller: 'SubModuleItemController',
};

angular
  .module('configuration-management.module')
  .component('subModuleItem', subModuleItem);
